module.exports = __webpack_public_path__ + "static/media/editor_ii.2805ff66.png";